import { routes } from '../../../constants';
import { ClassIndicators } from '../../../types/amr-pipeline/models/ClassIndicators';
import { Currency } from '../../../types/amr-pipeline/models/Currency';
import { SubscriptionFeature } from '../../../types/billing/SubscriptionFeature';
import { SecurityBwicLink } from './SecurityBwicLink';

type Props = {
    identifier?: string;
    identifiers?: ClassIndicators;
    className?: string;
    disabled?: boolean;
    secondaryPlaceholderColor?: boolean;
    currency?: Currency;
};

export function BwicMonitorLink({ identifiers, identifier, currency, className, secondaryPlaceholderColor }: Props) {
    return (
        <SecurityBwicLink
            identifier={identifier}
            identifiers={identifiers}
            className={className}
            currency={currency}
            iconName="bid"
            tooltipText="View BWIC"
            placeholderIfEmpty
            route={routes.allBWICs}
            secondaryPlaceholderColor={secondaryPlaceholderColor}
            requiredFeatures={[SubscriptionFeature.BwicMonitorHistoricalData]}
            emptyTooltipText="BWIC data is not available"
        />
    );
}
